import { Stack, Typography } from "@mui/material";
import ScheduleDefinitionEditor from "./ScheduleDefinitionEditor/ScheduleDefinitionEditor";
import { SchedulingStrategyEditorProps } from "../../../../types/actionModule/editor/schedulingStrategyEditorTypes";
import { isScheduleDefinitionSchedulingStrategyModel, ScheduleDefinitionSchedulingStrategyModel } from "../../../../types/actionModule/schedulingStrategy/schedulingStrategyType";
import { useTranslation } from "react-i18next";

export default function ScheduleDefinitionSchedulingStrategyEditor(props: SchedulingStrategyEditorProps) {
    const { t } = useTranslation();
    const value = props.value;

    if(!isScheduleDefinitionSchedulingStrategyModel(value)) {
        return <>Invalid value</>;
    }

    return <Stack sx={{gap: 2}} direction="column">
        <Typography variant="caption">{t("actionModules.schedulingStrategy.scheduleDefinition.description")}</Typography>
        <ScheduleDefinitionEditor
            scheduleDefinition={value.scheduleDefinition}
            onUpdateScheduleDefinition={(v) => props.onChanged({
                ...value,
                scheduleDefinition: v,
            } as ScheduleDefinitionSchedulingStrategyModel)} />
    </Stack>
}